import { bindConnect } from '../../../utils';
import Registration from './Registration';
import { doRegistration } from '../../../redux/actions/auth';

export default bindConnect(state => ({
  user: state.current_user.user
}), {
  doRegistration
})(Registration);
